import dynamic from 'next/dynamic';
import { PrepayRatesProps } from './PrepayRates.types';

export const PrepayRates = dynamic<PrepayRatesProps>(() => import('./PrepayRates').then(module => module.PrepayRates));
